import React, { ReactNode } from 'react';
import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Paper)(({ theme }) => ({
  position: 'relative',
  padding: 24,
  borderRadius: 12,
  width: '100%',
  backgroundColor: theme.palette.mode === 'dark' 
    ? 'rgba(255, 255, 255, 0.05)' 
    : 'rgba(0, 0, 0, 0.02)',
}));

interface PricingCardProps {
  children: ReactNode;
  elevation?: number;
  sx?: object;
}

export function PricingCard({ children, elevation = 0, sx }: PricingCardProps) {
  return (
    <StyledCard elevation={elevation} sx={sx}>
      {children}
    </StyledCard>
  );
}

